import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestHeaderModel } from '../views/models/request-header.model';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { RequestLineModel } from '../views/models/request-line.model';
import { ChatRecordsOnRequestModel } from '../views/models/chat-records-on-request.model';
import { delay, retryWhen, switchMap } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { PermissionsService } from './permissions.service';
import { PermissionSetsModel } from '../views/models/permission-sets.model';
import { environment } from '../../environments/environment';
import { TokenFormModel } from '../views/pages/auth/models/tokenform.model';
import { AppHotelService } from './app-hotel.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  ws: WebSocketSubject<RequestHeaderModel>;
  RETRY_SECONDS = 10;
  request_change$ = new BehaviorSubject<RequestHeaderModel[]>([]);
  point_request_change$ = new BehaviorSubject<RequestHeaderModel[]>([]);
  room_reservation_change$ = new BehaviorSubject<RequestHeaderModel[]>([]);
  request_change_filtered = new BehaviorSubject<RequestHeaderModel[]>([]);
  new_request_change = new BehaviorSubject<number>(0);
  request_profile_change$ = new BehaviorSubject<RequestHeaderModel[]>([]);
  request_by_profile_change$ = new BehaviorSubject<RequestHeaderModel[]>([]);
  request_by_item_change$ = new BehaviorSubject<RequestHeaderModel[]>([]);
  request_reservation_change$ = new BehaviorSubject<RequestHeaderModel[]>([]);
  spending_change = new BehaviorSubject<RequestLineModel[]>([]);
  check_in_request_change$ = new BehaviorSubject<RequestHeaderModel[]>(undefined);
  max_request_change$ = new BehaviorSubject<RequestHeaderModel>(new RequestHeaderModel());
  translated_text_change$ = new BehaviorSubject<string>('');
  currentRedeemRequest = new BehaviorSubject<RequestLineModel[]>([new RequestLineModel()]);

  refreshTrigger: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  profile: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

  constructor(
    private httpClient: HttpClient,
    private appHotel: AppHotelService,
    private router: Router,
    private translateService: TranslateService,
    private permissionsService: PermissionsService) {
  }

  connectWs(groupHotels: string): Observable<RequestHeaderModel> {
    // no more than one connection simultaneously
    if (!(this.ws == null)) {
      console.log('no more than one connection simultaneously');
      this.ws.complete();
    }
    let wsUri = environment.baseURL.replace('https://', 'wss://').replace('http://', 'ws://') + '/v2';
    wsUri += '/hotel_requests/' + (groupHotels || this.profile.app_hotel_id) + '/ws';
    return of(wsUri).pipe(
      switchMap(wsUrl => {
        console.log(wsUrl);
        if (this.ws) {
          return this.ws;
        } else {
          this.ws = webSocket(wsUrl);
          return this.ws;
        }
      }),
      retryWhen((errors) => errors.pipe(delay(this.RETRY_SECONDS)))
    );
  }

  disconnectWs() {
    console.log('disconnectWs');
    if (this.ws) {
      this.ws.complete();
      this.ws = null;
      console.log('IndisconnectWs');
    }
  }

  socketConnect() {
    this.appHotel.getHotelInfo(+localStorage.getItem('hotelId')).subscribe(
      (hotel) => {
        this.connectWs((hotel.group_hotels.split(',').join('-') ? hotel.group_hotels.split(',').join('-') : hotel.id.toString()))
          .subscribe(async (request) => {
            const appHotels = JSON.parse(localStorage.getItem('token_form')).app_hotels;

            if (hotel.group_hotels) {
              for (let i = 0; i < (appHotels.trim().split(',')).length; i++) {
                const groupIDs = hotel.group_hotels.trim().split(',');

                if (groupIDs.find(y => y == appHotels.trim().split(',')[i])) {
                  this.addRequest(request);
                  break;
                }
              }
            } else {
              this.addRequest(request);
            }
          }, (err) => {
            console.log('Web Socket Error : ' + err);
          }, () => {
            console.log('Web Socket is completed');
            setTimeout(() => {
            }, 200);
          });
      }
    );
  }

  // addRequest(request: RequestHeaderModel) {
  //   if (JSON.parse(localStorage.getItem('token_form')).role == 'admin') {
  //     if (+JSON.parse(localStorage.getItem('token_form')).app_hotel_id != request.hotel_id) {
  //       return;
  //     }
  //   }
  //   this.permissionsService.getPermissionSetByID(JSON.parse(localStorage.getItem('token_form')).id).subscribe(
  //     (permissions: PermissionSetsModel[]) => {
  //       permissions.forEach(x => {
  //         if (x.menu_section_id == request.menu_section_id && x.show) {
  //           if (this.request_change$.getValue()[0].id >= request.id) {
  //             const index = this.request_change$.getValue().findIndex(y => y.id == request.id);
  //             // this.request_change$.getValue()[index] = request;
  //             this.request_change$.getValue()[index].message_badge = request.message_badge;
  //             this.request_change$.getValue()[index].status = request.status;
  //           } else {
  //             const audio = new Audio();
  //             audio.src = './assets/audio/ring.wav';
  //             audio.load();
  //             audio.play();
  //             this.request_change$.getValue().push(request);
  //           }
  //           const sorted = this.request_change$.getValue().sort((a, b) => b.id - a.id);
  //           this.request_change$.next(sorted);
  //         }
  //       });
  //     }
  //   );
  // }

  getTranslate(key: string): Promise<string> {
    return new Promise((resolve) => {
      this.translateService.get(key).subscribe(
        (value: string) => {
          resolve(value);
        });
    });
  }

  async addRequest(request: RequestHeaderModel) {
    this.refreshTrigger.next(!this.refreshTrigger.getValue());

    const TOKEN: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

    if (TOKEN.role === 'admin') {
      if (TOKEN.app_hotel_id != request.hotel_id) {
        return;
      }
    }

    const PERMISSIONS = await this.permissionsService.getPermissionSet(TOKEN.id);

    if (PERMISSIONS.find(x => x.menu_section_id === request.menu_section_id && x.show)) {

      const REQ = this.request_change_filtered.getValue().find(y => y.id == request.id);

      if (!TOKEN.guest_visible) {
        if (request.menu_section_id) {
          request.display_name = request.profile_name.replace(/\w\S*/g, (txt) => (txt.charAt(0) + '*'.repeat(txt.length - 1)));
        }
      } else {
        request.display_name = request.profile_name;
      }

      if (REQ) {
        REQ.message_badge = request.message_badge;
        REQ.status = request.status;
        REQ.callback_survey_rating = request.callback_survey_rating;
        REQ.callback_note = request.callback_note;
        this.request_change_filtered.next(this.request_change_filtered.getValue());
      } else {
        // Show sweealert if user isn't on /home/requests page
        if (this.router.url !== '/home/requests') {

          Swal.fire({
            title: await this.getTranslate('New Request'),
            text: request.profile_name,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'View'
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/home/requests']);
            }
          });
        }

        try {
          const AUD = new Audio('assets/audio/notification.mp3');
          AUD.play();
        } catch {
        }

        this.request_change_filtered.next([request, ...this.request_change_filtered.getValue()]);
      }
    }
  }


  getRequest(item_id?: number, time_period?: string) {
    let queryParam = '';
    const queryParams: string[] = [];

    // time_period her zaman ekleniyor, verilmemişse varsayılan -14d kullanılıyor
    const period = time_period || '-14d';
    queryParams.push('time_period=' + period);

    queryParams.push('product_type=Guestny');

    if (queryParams.length > 0) {
      queryParam = '?' + queryParams.join('&');
    }

    this.httpClient.get(environment.baseURL + '/v2/api' + '/v2requests' + queryParam).subscribe(
      (requests: RequestHeaderModel[]) => {

        if (item_id) {
          requests = requests.filter(x => x.menu_item_id == item_id);
        }

        this.request_change$.next(requests);
        console.log(requests, "requests")
        this.request_change_filtered.next(requests);


        if (requests) {
          const newRequest: RequestHeaderModel[] = requests.filter(x => x.status == 'New');
          this.new_request_change.next(newRequest.length);
          this.room_reservation_change$.next(requests.filter(x => x.menu_section_id == 105));
        }
      }
    );
  }

  getAllRequests(): Promise<RequestHeaderModel[]> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/requests').subscribe(
        (requests: RequestHeaderModel[]) => {
          resolve(requests);
        }
      );
    });
  }

  getRequestById(requestID) {
    this.httpClient.get<RequestHeaderModel>(environment.baseURL + '/v2/api' + '/request/' + requestID).subscribe(
      (requests: RequestHeaderModel) => {
        console.log(requests);
        this.currentRedeemRequest.next(requests.requestlines);
      }
    );

    // return this.httpClient.get<RequestHeaderModel>(environment.baseURL + '/v2/api' + '/request/' + requestID);

  }

  getOnlineRequest() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/online_check_in').subscribe(
      (requests: RequestHeaderModel[]) => {
        this.check_in_request_change$.next(requests);
      }
    );
  }

  getRequestByProfileId(id) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/request_by_profile_id/' + id).subscribe(
      (requests: RequestHeaderModel[]) => {
        this.request_by_profile_change$.next(requests);
        const lines: RequestLineModel[] = [];
        requests.forEach(x => {
          if (x.requestlines) {
            x.requestlines.forEach(y => {
              y.date = x.order_date.toString();
              if (y.unit_price != 0) {
                lines.push(y);
              }
            });
          }
        });
        this.spending_change.next(lines);

        this.point_request_change$.next(requests.filter(x => x.point > 0));
      }
    );
  }


  getRequestByProfileID(profile_id: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/requests/' + profile_id).subscribe(
      (requests: RequestHeaderModel[]) => {
        this.request_profile_change$.next(requests);
      }
    );
  }

  getReservationRequestByID(profile_id: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/reservation_requests/' + profile_id).subscribe(
      (requests: RequestHeaderModel[]) => {
        this.request_reservation_change$.next(requests);
      }
    );
  }

  putStatus(id: number, UserName: string, Status: string, StaffNote: string, PlaceCode: string) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/request_set_status/' + id,
      {
        user_name: UserName,
        status: Status,
        staff_note: StaffNote,
        place_code: PlaceCode
      }).subscribe(
        res => {
          // this.getRequest();
        },
        (error2 => {
          console.log(error2);
        }),
        () => {
          console.log('ok');
        }
      );
  }

  putRedeemStatus(id: string) {
    return new Promise((resolve, reject) => {
      this.httpClient.put(environment.baseURL + '/v2/api' + '/redeem_voucher/' + id, {
        note: 'note'
      }).subscribe(
        res => {
          this.getRequest();
          console.log(res, id);
          resolve(res);
        },
        (error2 => {
          reject(error2);
        }),
        () => {
          console.log('ok');
        }
      );
    });
  }

  putRequest(request) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/request', request).subscribe(
      res => {
        this.getRequest();
        console.log(res);
      },
      (error2 => {
        console.log(error2);
      }),
      () => {
        console.log('ok');
      }
    );
  }

  translateText(text) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/text_detect?text=' + text, {
      observe: 'body',
      responseType: 'json'
    }).subscribe(
      (data: string) => {
        if (data != null) {
          this.translated_text_change$.next(data);
          console.log('data: ' + data);
        } else {
          this.translated_text_change$.next('Dil türkçe olduğundan çevrilemedi!!');
        }
      }
    );
  }

  postRequest(request: RequestHeaderModel[]) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(environment.baseURL + '/v2/api' + '/request', request).subscribe(
        async (resp: number[]) => {
          resolve(resp);
          console.log(resp);
        }, (err) => {
          reject(err);
        }
      );
    });

  }

  /*
   getOrderSummaryReport : Get Order Count and Total Order Amount summary for date range
 */
  getOrderSummaryReport(startDate: string, endDate: string): Promise<OrderSummaryReportModel> {
    return new Promise((resolve, reject) => {
      this.httpClient.get<OrderSummaryReportModel>(`${environment.baseURL}/v2/api/sales_transactions_summary/${startDate}/${endDate}`)
        .subscribe({
          next: res => {
            resolve(res);
          }, error: err => {
            reject(err);
          }
        });
    });
  }

  getTop10ProductSummaryReport(startDate: string, endDate: string): Promise<Top10ProductReportModel[]> {
    return new Promise((resolve, reject) => {
      this.httpClient.get<Top10ProductReportModel[]>(`${environment.baseURL}/v2/api/sales_transactions_top_10/${startDate}/${endDate}`)
        .subscribe({
          next: res => {
            resolve(res);
          }, error: err => {
            reject(err);
          }
        });
    });
  }
}
